import type { ReactNode } from 'react';
import { Button } from 'antd';
import type { ButtonProps, TooltipProps } from 'antd';
import clsx from 'clsx';
import Tooltip from 'components/Tooltip';

type Props = Omit<ButtonProps, 'type' | 'icon' | 'children'> & {
  label: string;
  children: ReactNode;
  qaSelector?: string;
  tooltipProps?: Omit<TooltipProps, 'title'>;
};

// An icon that acts on click: a real button named by its tooltip text, with no box of its own.
function IconButton({
  label,
  children,
  qaSelector,
  tooltipProps,
  className,
  ...rest
}: Props) {
  return (
    <Tooltip
      title={label}
      placement='bottom'
      arrow={false}
      {...tooltipProps}
      className={clsx('iconButtonAnchor', tooltipProps?.className)}
    >
      <Button
        type='text'
        className={clsx('iconButton', className)}
        data-qa-selector={qaSelector}
        {...rest}
        aria-label={label}
      >
        {children}
      </Button>
    </Tooltip>
  );
}

export default IconButton;
